import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { emailChangeActions } from '../+state/email-change/email-change.actions';
import { emailChangeFeature } from '../+state/email-change/email-change.reducer';
import { EmailChangeVerify } from '../entities/email-change.entity';

@Injectable({ providedIn: 'root' })
export class EmailChangeFacade {
  readonly #store: Store = inject(Store);

  public requestId$ = this.#store.select(emailChangeFeature.selectRequestId);
  public selectOldEmailVerified$ = this.#store.select(emailChangeFeature.selectOldEmailVerified);
  public selectOldEmailError$ = this.#store.select(emailChangeFeature.selectOldEmailError);
  public selectNewEmailVerified$ = this.#store.select(emailChangeFeature.selectNewEmailVerified);
  public selectNewEmailError$ = this.#store.select(emailChangeFeature.selectNewEmailError);
  public selectErrors$ = this.#store.select(emailChangeFeature.selectError);

  public startProcess(newEmail: string): void {
    this.#store.dispatch(emailChangeActions.startProcess({ newEmail }));
  }

  public async requestTan() {
    const requestId = await firstValueFrom(this.requestId$);
    this.#store.dispatch(emailChangeActions.requestTan({ requestId: requestId }));
  }

  public async verifyTan(tan: string) {
    const requestId = await firstValueFrom(this.requestId$);

    const payload: EmailChangeVerify = {
      tan,
      requestId,
    };
    this.#store.dispatch(emailChangeActions.verify({ payload }));
  }

  public async sendCodeOldEmail() {
    const requestId = await firstValueFrom(this.requestId$);
    this.#store.dispatch(emailChangeActions.sendCodeOldEmail({ requestId }));
  }

  public async verifyOldEmail(code: string) {
    const requestId = await firstValueFrom(this.requestId$);
    this.#store.dispatch(emailChangeActions.verifyOldEmail({ code, requestId }));
  }

  public async sendCodeNewEmail() {
    const requestId = await firstValueFrom(this.requestId$);
    this.#store.dispatch(emailChangeActions.sendCodeNewEmail({ requestId }));
  }

  public async verifyNewEmail(code: string) {
    const requestId = await firstValueFrom(this.requestId$);
    this.#store.dispatch(emailChangeActions.verifyNewEmail({ code, requestId }));
  }

  public async abortProcess() {
    const requestId = await firstValueFrom(this.requestId$);
    this.#store.dispatch(emailChangeActions.abortProcess({ requestId }));
  }
}
